import React from "react"

import { ErrorPageView } from "./ErrorPageView"
import { useErrorPageViewModel } from "./hooks/useErrorPageViewModel"

export interface ErrorPageProps {
  clearError?: () => void
}

export const ErrorPage = React.memo((props: ErrorPageProps) => (
  <ErrorPageView {...useErrorPageViewModel(props)} />
))
